import { useTranslation } from 'react-i18next'
import type { KpiCardsData } from './api'

interface Props {
  data: KpiCardsData | null
}

function fmt(n: number): string {
  return n.toLocaleString('nb-NO')
}

export default function KpiCards({ data }: Props) {
  const { t } = useTranslation('bruktbil')
  if (!data) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {[0, 1, 2].map(i => (
          <div key={i} data-testid="kpi-skeleton" className="card p-4 animate-pulse h-20 bg-gray-100 dark:bg-dark-border rounded-lg" />
        ))}
      </div>
    )
  }

  const cards = [
    { label: t('oversikt.kpi.overdragelser'), value: fmt(data.total_transfers) },
    { label: t('oversikt.kpi.unikeSelgere'), value: fmt(data.unique_sellers) },
    { label: t('oversikt.kpi.unikeKjopere'), value: fmt(data.unique_buyers) },
  ]

  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
      {cards.map(({ label, value }) => (
        <div key={label} className="card p-4">
          <p className="text-xs text-gray-500 dark:text-gray-400 uppercase tracking-wide">{label}</p>
          <p className="text-2xl font-semibold mt-1">{value}</p>
        </div>
      ))}
    </div>
  )
}
